import { render } from "./CompanyTechnology.vue?vue&type=template&id=2749e4bc&scoped=true"
import script from "./CompanyTechnology.vue?vue&type=script&lang=js"
export * from "./CompanyTechnology.vue?vue&type=script&lang=js"

import "./CompanyTechnology.vue?vue&type=style&index=0&id=2749e4bc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2749e4bc"]])

export default __exports__